import { ReactElement, useEffect } from 'react';

import { faXmarkLarge } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@mui/material';
import { ToastStore } from '@stores/models/store';
import { closeSnackbar, useSnackbar } from 'notistack';

interface Props {
  toast: ToastStore;
}
const Toast = ({ toast }: Props): ReactElement => {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    enqueueSnackbar(toast.message, {
      variant: toast.level,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
      persist: toast.persist,
      action:
        toast.showCloseButton &&
        ((snackbarId) => (
          <IconButton
            size="small"
            onClick={() => closeSnackbar(snackbarId)}
            sx={{ color: 'white' }}
          >
            <FontAwesomeIcon icon={faXmarkLarge} size="sm" />
          </IconButton>
        )),
    });
  }, []);
  return <></>;
};

export default Toast;
